interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  addMargin?: boolean;
}

export default function Container({ children, className = '', addMargin }: ContainerProps) {
  const common = `sh-container mx-auto grid ${addMargin ? 'mt-sh-60' : ''}`;
  const mobile = 'max-w-[398px] grid-cols-4 gap-4 px-4';
  const desktop = 'lg:max-w-[1276px] lg:grid-cols-12 md:gap-4 lg:px-4';
  const tablet = 'md:max-w-[912px] md:grid-cols-8 md:gap-4 md:px-4';
  return <div className={`${common} ${mobile} ${tablet} ${desktop}  ${className}`}>{children}</div>;
}
